(() => {
  if (window.prPersonalizationBound) return;
  window.prPersonalizationBound = true;

  const updateCount = (field) => {
    const out = field.parentElement && field.parentElement.querySelector('[data-pz-count-out]');
    if (out) out.textContent = `${field.value.length}/${field.maxLength}`;
  };

  document.addEventListener('input', (event) => {
    const field = event.target;
    if (field.matches && field.matches('[data-pz-count]')) updateCount(field);
  });

  const bindForm = (box) => {
    const formId = box.dataset.pzForm;
    const form = formId ? document.getElementById(formId) : null;
    if (!form || form.dataset.pzBound) return;
    form.dataset.pzBound = 'true';
    form.addEventListener(
      'submit',
      (event) => {
        const fields = box.querySelectorAll('[required]');
        let firstInvalid = null;
        fields.forEach((field) => {
          if (!field.checkValidity() && !firstInvalid) firstInvalid = field;
        });
        box.classList.add('pz--validated');
        if (firstInvalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          firstInvalid.reportValidity();
          firstInvalid.focus();
        }
      },
      true
    );
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-pz-chart]');
    if (!trigger) return;
    const box = trigger.closest('[data-pz]');
    const dialog = box && box.querySelector('[data-pz-dialog]');
    if (!dialog) return;
    const img = dialog.querySelector('img');
    img.src = trigger.dataset.pzChart;
    img.alt = trigger.dataset.pzChartAlt || '';
    if (!dialog.open) dialog.showModal();
  });

  document.addEventListener('click', (event) => {
    const close = event.target.closest('[data-pz-dialog-close]');
    if (close) close.closest('dialog').close();
    const dialog = event.target.closest('dialog[data-pz-dialog]');
    if (dialog && event.target === dialog) dialog.close();
  });

  const init = () => {
    document.querySelectorAll('[data-pz]').forEach((box) => {
      box.querySelectorAll('[data-pz-count]').forEach(updateCount);
      bindForm(box);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
